import {
    SimpleListEntitiesAllowedEnum,
    SimpleListEntitiesResponseContent
} from '@/api/resources/common/simple-list-entities/simple-list-entities.dto'
import { commonSimpleListEntity } from '@/api/resources/common/simple-list-entities/simple-list-entities.service'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import {
    delayAndResponseTimesDossierService
} from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.service'
import {
    StatisticalAnalysisSidebarItemCombo
} from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import {
    initialStatisticalAnalysisViewDetailChartFiltersExtendedState,
    StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters,
    StatisticalAnalysisViewDetailChartFilterByValuesBase,
    StatisticalAnalysisViewDetailChartFilterByValuesPortions,
    StatisticalAnalysisViewDetailChartFilterByValuesSamples,
    StatisticalAnalysisViewDetailChartFilterByValuesSubportions,
    StatisticalAnalysisViewDetailChartFiltersExtendedFilters,
    StatisticalAnalysisViewDetailChartFiltersExtendedState
} from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-extended/statistical-analysis-view-detail-chart-filters-extended.model'
import {
    StatiscalAnalysisTypeCases,
    StatisticalAnalysisDossiersExternalInfo
} from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { Nullable } from '@/shared/types/app.types'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisViewDetailChartFiltersExtended extends Vue {
    @Prop() readonly externalInfo!: StatisticalAnalysisDossiersExternalInfo
    @Prop() readonly mainFilter!: CommonPersonnelResponse[]
    @Prop() readonly additionalFilterBy!: StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters
    @Prop() readonly additionalFilterById!: StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters
    @Prop() readonly isVisible!: boolean

    @Emit()
    changedFilters(filters: StatisticalAnalysisViewDetailChartFiltersExtendedFilters): StatisticalAnalysisViewDetailChartFiltersExtendedFilters {
        return filters
    }

    state: StatisticalAnalysisViewDetailChartFiltersExtendedState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisViewDetailChartFiltersExtendedState()
    }

    get isSidepanelVisible(): boolean {
        return this.state.sidepanelVisible
    }

    get isLoading(): boolean {
        return this.state.loading
    }

    get isExternalLoading(): boolean {
        return this.state.externalLoading
    }

    get isFilterByIdActive(): boolean {
        return !!this.state.filters.filterBy.selected
    }

    get canApply(): boolean {
        if (!this.state.filters.filterBy.selected) {
            return true
        } else {
            return !!this.state.filters.filterBy.selected && !!this.state.filters.filterById.selected
        }
    }

    created() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    async onOpenSidepanel(): Promise<void> {
        this.state.sidepanelVisible = true
        this.state.loading = true
        this._loadListFilterBy()
        this.state.filters.mainFilter.selected = this.mainFilter?.length ? this.mainFilter : []
        this.state.filters.filterBy.selected = this.additionalFilterBy?.id ? this.additionalFilterBy : null
        this.state.filters.filterById.selected = this.additionalFilterById?.id ? this.additionalFilterById : null
        await this._getMainFilters(this.mainFilter)
        if (this.additionalFilterById?.id) {
            await this._getAdditionalFilterById(
                (this.additionalFilterBy),
                (this.additionalFilterById?.id as number)
            )
        }
        this.state.loading = false
    }

    onCloseSidepanel():void {
        this.state.sidepanelVisible = false
    }

    onClearAll(): void {
        this.state = {
            ...this.state,
            filters: {
                ...this.state.filters,
                mainFilter: {
                    ...this.state.filters.mainFilter,
                    selected: []
                },
                filterBy: {
                    ...this.state.filters.filterBy,
                    selected: null
                },
                filterById: {
                    ...this.state.filters.filterById,
                    selected: null
                }
            }
        }
    }

    onApply(): void {
        this.changedFilters(this.state.filters)
        this.onCloseSidepanel()
    }

    async onChangeFilterBy(value: Nullable<StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters>): Promise<void> {
        if (value) {
            await this._getAdditionalFilterById(value)
        } else {
            this.state.filters.filterBy.selected = null
            this.state.filters.filterById.list = []
            this.state.filters.filterById.selected = null
        }
    }

    private _loadListFilterBy(): void {
        switch ((this.externalInfo.typeSearch as StatisticalAnalysisSidebarItemCombo).id) {
        case StatiscalAnalysisTypeCases.CASE:
            this.state.filters.filterBy.list = StatisticalAnalysisViewDetailChartFilterByValuesBase()
            break
        case StatiscalAnalysisTypeCases.SAMPLE:
            this.state.filters.filterBy.list = StatisticalAnalysisViewDetailChartFilterByValuesBase().concat(StatisticalAnalysisViewDetailChartFilterByValuesSamples())
            break
        case StatiscalAnalysisTypeCases.PORTION:
            this.state.filters.filterBy.list = StatisticalAnalysisViewDetailChartFilterByValuesBase().concat(StatisticalAnalysisViewDetailChartFilterByValuesSamples(), StatisticalAnalysisViewDetailChartFilterByValuesPortions())
            break
        case StatiscalAnalysisTypeCases.SUBPORTION:
            this.state.filters.filterBy.list = StatisticalAnalysisViewDetailChartFilterByValuesBase().concat(StatisticalAnalysisViewDetailChartFilterByValuesSamples(), StatisticalAnalysisViewDetailChartFilterByValuesPortions(), StatisticalAnalysisViewDetailChartFilterByValuesSubportions())
            break
        default:
            this.state.filters.filterBy.list = StatisticalAnalysisViewDetailChartFilterByValuesBase()
            break
        }
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.externalLoading = value
    }

    private async _getMainFilters(options: CommonPersonnelResponse[]): Promise<void> {
        const response = await this.$_toCallSecure(delayAndResponseTimesDossierService.getPersonnel(this.externalInfo))
        if (!response) {
            this.state.filters.mainFilter.list = []
            this.state.filters.mainFilter.selected = null
        } else {
            this.state.filters.mainFilter.list = response
            this.state.filters.mainFilter.selected = response.filter((item: CommonPersonnelResponse) => options.find((option: CommonPersonnelResponse) => option.id === item.id))
        }
    }

    private async _getAdditionalFilterById(entity: Nullable<StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters>, optionSelected?: number): Promise<void> {
        this.state.loading = true
        let response
        if (entity?.entityId) {
            response = await this.$_toCallSecure(commonSimpleListEntity.getListOfEntity(entity.entityId, { size: PAGINATOR_BIG_PAGE_SIZE }))
        } else {
            response = await this.$_toCallSecure(commonSimpleListEntity.getListOfEntity((entity?.id as SimpleListEntitiesAllowedEnum), { size: PAGINATOR_BIG_PAGE_SIZE }))
        }
        if (!response) {
            this.state.filters.filterById.list = []
            this.state.filters.filterById.selected = null
        } else {
            this.state.filters.filterBy.selected = this.state.filters.filterBy.list.find((item: SimpleListEntitiesResponseContent) => item.id === entity?.id)
            this.state.filters.filterById.list = response.content
            this.state.filters.filterById.selected = response.content.find((item: SimpleListEntitiesResponseContent) => item.id === optionSelected)
        }
        this.state.loading = false
    }
}
